import { useEffect, useState } from "react";
import { api, errMsg, toApiItems } from "@/lib/api";

export function useQuote(items) {
  const [quote, setQuote] = useState(null);
  const [error, setError] = useState(null);
  const key = items.map((i) => `${i.id}:${i.qty}`).join(",");
  useEffect(() => {
    if (!items.length) return setQuote(null);
    const t = setTimeout(() => {
      api.post("/delivery/quote", { items: toApiItems(items) })
        .then((r) => { setQuote(r.data); setError(null); })
        .catch((e) => { setQuote(null); setError(errMsg(e)); });
    }, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return quote ? quote : error ? { error } : null;
}
